// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__cwCsL","loaderContainer":"Spinner_loaderContainer__1dCC0","load2":"Spinner_load2__3XfsW"};